import React from 'react';
import { Route, Routes } from 'react-router-dom';
import SignupPage from './pages/signup_page';
import LoginPage from './pages/login_page';
import SignupConfirmationPage from './pages/signup_confirmation_page';
import CreateStudioListingPage from './pages/create_studio_listing_page';
import LogoutPage from './pages/logout_page';
import SearchStudioPage from './pages/search_studio_page';
import StudioViewPage from './pages/studio_view_page';
import EditStudioPage from './pages/edit_studio_page';
import EditProfilePage from './pages/edit_profile_page';
import BookingPage from './pages/booking_list_page';
import ProfileViewPage from './pages/profile_view_page';
import ForgetPasswordPage from './pages/forget_password_page';

const Router: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<SearchStudioPage />} />
      <Route path="/auth/signup" element={<SignupPage />} />
      <Route path="/auth/login" element={<LoginPage />} />
      <Route path="/auth/forget-password" element={<ForgetPasswordPage />} />
      <Route path="/auth/logout" element={<LogoutPage />} />
      <Route path="/auth/confirmation" element={<SignupConfirmationPage />} />
      <Route path="/settings/profile" element={<EditProfilePage />} />
      <Route path="/profile/:userId" element={<ProfileViewPage />} />
      <Route path="/bookings" element={<BookingPage />} />
      <Route path="/studio-listings/add" element={<CreateStudioListingPage />} />
      <Route path="/studio/:studioId" element={<StudioViewPage />} />
      <Route path="/studio/:studioId/edit" element={<EditStudioPage />} />
      <Route path='*' element={<div>404</div>} />
    </Routes>
  );
};

export default Router
